import React, { SVGProps } from 'react';

const Bank: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 32 32'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M3 12h26L16 4zm4 0v10m6-10v10m6-10v10m6-10v10M4 22h24M2 26h28'
        />
    </svg>
);

export default Bank;
